<template lang="pug">
BriqTable
  thead
    th Object type
    th Reference
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ item.ObjectType }}
        td {{ item.Reference }}
        td
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              thead
                th Meta data
              tbody
                tr
                  td 
                    textarea(readonly) {{ item.MetaData }}        
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'MetaDataTable',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
